import React, { useState } from "react";

import type { CompanyResearchIntentType } from "../lib/companyResearch";

export function shouldPromptForSelfCompanyUrl(intentType: CompanyResearchIntentType) {
  return intentType === "sales" || intentType === "partnership";
}

type CompanyResearchSelfUrlModalProps = {
  intentType: CompanyResearchIntentType | null;
  onClose: () => void;
  onSubmit: (selfCompanyUrl: string | null) => void;
};

export function CompanyResearchSelfUrlModal({
  intentType,
  onClose,
  onSubmit,
}: CompanyResearchSelfUrlModalProps) {
  const [selfCompanyUrl, setSelfCompanyUrl] = useState("");

  if (!intentType) return null;

  const submitWithUrl = () => {
    onSubmit(selfCompanyUrl.trim() || null);
    setSelfCompanyUrl("");
  };

  const submitWithoutUrl = () => {
    onSubmit(null);
    setSelfCompanyUrl("");
  };

  const close = () => {
    setSelfCompanyUrl("");
    onClose();
  };

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="self-company-url-title"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/35 px-4 py-6"
    >
      <div className="w-full max-w-md rounded-2xl border border-[#EADBC8] bg-white p-5 shadow-[0_24px_60px_rgba(74,62,57,0.24)]">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h2 id="self-company-url-title" className="text-base font-black text-[#5D4D46]">
              自社情報を追加できます
            </h2>
            <p className="mt-3 text-sm font-bold leading-6 text-[#6B5851]">
              営業・協業分析には自社情報があると精度が上がります。
              自社URLを入力すると、相手企業との接点を踏まえた分析ができます。
            </p>
          </div>
          <button
            type="button"
            onClick={close}
            className="shrink-0 rounded-full border border-[#EADBC8] bg-white px-3 py-1 text-xs font-black text-[#8A746A] hover:bg-[#FFF7F2]"
          >
            閉じる
          </button>
        </div>

        <label className="mt-5 block">
          <span className="text-xs font-black text-[#5D4D46]">自社URL 任意</span>
          <input
            type="url"
            value={selfCompanyUrl}
            onChange={(event) => setSelfCompanyUrl(event.target.value)}
            className="mt-2 w-full rounded-2xl border border-[#EADBC8] bg-white px-4 py-3 text-sm text-[#4A3E39] outline-none transition focus:border-[#A67C52] focus:ring-2 focus:ring-[#F1D8C6]"
            placeholder="https://example.co.jp/"
          />
        </label>

        <div className="mt-5 grid gap-3 sm:grid-cols-2">
          <button
            type="button"
            onClick={submitWithUrl}
            className="min-h-[44px] rounded-full bg-[#7C5A4E] px-4 py-2 text-sm font-black text-white transition hover:bg-[#5D4D46]"
          >
            自社URLを使って分析
          </button>
          <button
            type="button"
            onClick={submitWithoutUrl}
            className="min-h-[44px] rounded-full border border-[#D8C0AF] bg-white px-4 py-2 text-sm font-black text-[#7C5A4E] transition hover:border-[#A67C52] hover:bg-[#FFF7F2]"
          >
            自社情報なしで分析
          </button>
        </div>
      </div>
    </div>
  );
}
